// extracted by mini-css-extract-plugin
module.exports = {"dek":"dek___4eCJu","title":"title___Y6Ux8"};